import React, { useEffect, useState, useRef } from 'react';
import { useLocation, RouteComponentProps } from 'react-router-dom';

import MaterialTable, { MTableToolbar } from 'material-table';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { StockReceipt } from '../../models';
import { PaginatedResponse } from '../../../shared/models';
import { Filter } from '../../../shared/models/Filter';

import { getStockReceiptsByPage, getKoronaSuppliersList } from '../../api';
import { checkStatus, parseJSON, handleError } from '../../../shared/api/core/common';
import { SVG_ICONS } from '../../../shared/icons/SvgIcons';
import { EMPTY_ROW_MSG, ERROR_500, ERROR_MSG } from '../../../shared/lib/Localization';
import { initQueryParams, replaceHistory, tableOptions, useQuery } from '../../../shared/lib/TableQueryParams';
import { ErrorStatusBar, CustomTableTitle } from '../../../shared/components';
import { AvailableFilters, SelectedFilters, FilterRow } from '../../../products/components/Filters';
import {
  SuggestedPricePageLoadInput,
  resolveSuggestedPricePageLoad,
} from '../../screens/SuggestedPriceByMargin/suggestedPricePageLoad';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
  }),
);

const FILTERS: Filter[] = [
  {
    id: 'f1',
    label: 'Suppliers',
    name: 'KSUPPLIERS',
    types: [
      { id: '1', value: 'korona_supp_uuids_in', label: 'is equal' },
      { id: '2', value: 'korona_supp_uuids_not_in', label: 'is not equal' },
    ],
    selectedType: 'korona_supp_uuids_in',
    value: [],
    url: 'korona/supplier-list',
    labelField: 'name',
    bindValue: 'uuid',
    isResponsePaginated: true,
    data: null
  },

]

interface LocationState {
  redirected?: boolean;
}

export interface StockReceiptSupplierListUserData {
  selectedBusiness: { business_id: string };
}

export interface StockReceiptSupplierListProps {
  title: string;
  detailPath: string;
  userData: StockReceiptSupplierListUserData;
  history: RouteComponentProps['history'];
}

const StockReceiptSupplierList = (props: StockReceiptSupplierListProps) => {
  const classes = useStyles({});
  const [emptyDataSourceMessage, setEmptyDataSourceMessage] = useState(EMPTY_ROW_MSG);
  const [isErrorStatusVisible, setErrorStatusVisible] = useState(false);
  let tableRef = useRef<{ onQueryChange: any; onChangePage: any; }>();

  let locationQuery = useQuery(useLocation);
  const [tableQuery, setTableQuery] = useState(initQueryParams(locationQuery));
  const [isLoading, setLoading] = useState(false);
  const loadGeneration = useRef(0);
  const appliedFilter = useRef<string | null>(null);
  const hasLoaded = useRef(false);
  const appliedPageSize = useRef<number | null>(null);
  const [filterVisible, showFilters] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [filterString, setFilterString] = useState('');
  const [updatedFilters, setUpdatedFilters] = useState(null as any)
  const [koronaSuppliersList, setFilterKoronaSuppliersList] = useState(null)
  const location = useLocation<LocationState>();

  useEffect(() => {
    if (location.state && location.state?.redirected) {
      console.log('This page was redirected');
      window.location.reload();
    }
  }, [location]);

  useEffect(() => {
    if (!isLoading) {
      tableRef.current && tableRef.current.onQueryChange();
    }
  }, [props.userData.selectedBusiness]);

  const describePageLoad = (overrides: Partial<SuggestedPricePageLoadInput> = {}) =>
    resolveSuggestedPricePageLoad({
      requestedPage: tableQuery.page,
      requestedPageSize: tableQuery.pageSize,
      urlPage: tableQuery.page,
      urlPageSize: tableQuery.pageSize,
      filterString,
      previousFilterString: appliedFilter.current,
      hasLoaded: hasLoaded.current,
      appliedPageSize: appliedPageSize.current,
      requestId: loadGeneration.current,
      latestRequestId: loadGeneration.current,
      responseCount: null,
      responseRowCount: 0,
      previousTotalCount: tableQuery.totalCount,
      ...overrides,
    });

  useEffect(() => {
    const decision = describePageLoad();
    if (decision.resetToPageZero) {
      loadGeneration.current += 1;
      tableRef.current && tableRef.current.onChangePage(null, 0);
    }
    appliedFilter.current = filterString;
  }, [filterString]);

  useEffect(() => {
    const sb = props.userData.selectedBusiness;
    let payload = { buss_id: sb.business_id }
    getKoronaSuppliersList(payload)
      .catch(handleError) // handle network issues
      .then(checkStatus)
      .then(parseJSON)
      .then((data: any) => {
        // console.log("results",data)
        setFilterKoronaSuppliersList(data);
      })
      .catch((error: any) => {
      });
  }, [props.userData.selectedBusiness])


  useEffect(() => {
    if (koronaSuppliersList) {
      if (koronaSuppliersList.length > 0) {
        let currentFilters = [...FILTERS]
        let suppFilterIndexFound = currentFilters.findIndex(cf => cf.name === 'KSUPPLIERS')
        if (suppFilterIndexFound > -1) {
          currentFilters[suppFilterIndexFound].data = koronaSuppliersList
        }
        setUpdatedFilters([...currentFilters])
      }
    }

  }, [koronaSuppliersList])




  useEffect(() => {
    const activeFilters = selectedFilters.filter(
      (f: Filter) => (f.selectedType && f.value && f.value.length > 0) || (f.selectedType.includes('range') && (f.minValue || f.maxValue))
    );
    let filterString = '';
    activeFilters.forEach((f: Filter) => {
      let filterValue = '';
      let isRangeFilter = f.selectedType.includes('range');
      // let isChoiceFilter = !f.url && !Array.isArray(f.value) && !f.selectedType.includes('range')&& Array.isArray(f.choices)
      if (f.url && Array.isArray(f.value)) {
        const mappedValues = f.value.map((v) => v[f.bindValue]);
        filterValue = mappedValues.toString();
      }
      // if (isChoiceFilter) {
      //     filterString += `&${f.selectedType}=${f.value}`;
      //     console.log("CHOICE-FILTER-STRING",filterString)
      // }
      else if (!isRangeFilter) {

        // value is string
        filterValue = f.value.toString();

      }
      if (isRangeFilter) {
        if (f.minValue) {
          filterString += `&${f.selectedType}_min=${f.minValue}`;
        }
        if (f.maxValue) {
          filterString += `&${f.selectedType}_max=${f.maxValue}`;
        }
      }
      else {
        filterString += `&${f.selectedType}=${filterValue}`;
      }
    });
    setFilterString(filterString);
  }, [selectedFilters]);

  const toggleFilterPanel = () => {
    showFilters(!filterVisible);
  };

  const addFilter = (filter) => {
    if (!selectedFilters.find(f => f.id === filter.id)) {
      const filters = [...selectedFilters];
      filters.push(filter);
      setSelectedFilters(filters);
    }
  };

  const removeFilter = (index) => {
    const filters = [...selectedFilters];
    filters.splice(index, 1);
    setSelectedFilters(filters);
  };

  const updateFilter = (filter, index) => {
    const filters = [...selectedFilters];
    filters.splice(index, 1, filter);
    // console.log("Updated-Filter",filters)
    setSelectedFilters(filters);
  };


  const navigateToStockReceiptDetail = (rowData: any) => {
    props.history.push(props.detailPath + rowData.uuid, rowData);
  };



  return (
    <div>
      <ErrorStatusBar isVisible={isErrorStatusVisible} />
      <div style={{ maxWidth: '100%' }}>
        <MaterialTable
          options={{
            ...tableOptions(tableQuery),
            thirdSortClick: false,
            draggable: false,
            sorting: true,
            // Material-table slices remote rows again using initialPage.
            // Leave it at 0 so a page the server already returned is shown.
            initialPage: 0,
          }}
          components={{
            Toolbar: (props) => (
              <>
                <MTableToolbar {...props} />
                {filterVisible && (
                  <>
                    <FilterRow
                      {...props}
                      renderAvailableFilters={
                        <AvailableFilters
                          filters={updatedFilters ? updatedFilters : FILTERS}
                          addFilter={addFilter}
                        />
                      }
                      renderSelectedFilters={
                        <SelectedFilters
                          selectedFilters={selectedFilters}
                          removeFilter={removeFilter}
                          updateFilter={updateFilter}
                          businessId={null}
                        />
                      }
                    />
                  </>
                )}
              </>
            ),
          }}
          tableRef={tableRef}
          localization={{
            body: {
              emptyDataSourceMessage: emptyDataSourceMessage
            }
          }}
          columns={[
            {
              title: 'Date',
              field: 'createTime',
              render: rowData => (
                rowData.createTime ?
                  <span>{moment(rowData.createTime).format('YYYY-MM-DD HH:mm')}</span>
                  : <span></span>
              ),
            },
            { title: 'Number', field: 'number' },
            {
              title: 'Items',
              field: 'items_count',
              render: rowData => {
                if (rowData && rowData.items_count) {
                  return <span>{rowData.items_count}</span>;
                }
                return <span></span>;
              },
            },
            {
              title: 'Warehouse',
              field: 'target',
              render: rowData => {
                if (rowData && rowData.target && rowData.target.name) {
                  return <span>{rowData.target.name}</span>;
                }
                return <span></span>;
              }
            },
            {
              title: 'Supplier',
              field: 'supplier',
              render: rowData => {
                if (rowData && rowData.supplier && rowData.supplier.name) {
                  return <span>{rowData.supplier.name}</span>;
                }
                return <span></span>;
              },
            }
          ]}
          data={query =>
            new Promise((resolve, reject) => {
              const requestId = ++loadGeneration.current;
              const decision = describePageLoad({
                requestedPage: query.page,
                requestedPageSize: query.pageSize,
                requestId,
                latestRequestId: loadGeneration.current,
              });
              const sb = props.userData.selectedBusiness;

              if (sb && sb.business_id) {
                replaceHistory(
                  { ...query, page: decision.page, pageSize: decision.pageSize },
                  props.history,
                );
                let pageData = {
                  data: [] as StockReceipt[],
                  totalCount: 0,
                  page: decision.page
                };
                let orderBy = '';
                if (query.orderBy) {
                  orderBy = query.orderBy.field as string;
                  if (orderBy == 'supplier') {
                    orderBy = 'supplier__name';
                  }
                  if (orderBy == 'target') {
                    orderBy = 'target__name';
                  }
                  orderBy = `${query.orderDirection && query.orderDirection === 'desc' ? '-' : ''}${orderBy}`;
                  console.log("DIRECTION", orderBy)
                }
                setLoading(true);

                const settle = (responseCount: number | null, responseRowCount: number) =>
                  describePageLoad({
                    requestedPage: decision.page,
                    requestedPageSize: decision.pageSize,
                    requestId,
                    latestRequestId: loadGeneration.current,
                    responseCount,
                    responseRowCount,
                  });

                getStockReceiptsByPage(
                  sb.business_id,
                  decision.page + 1,
                  decision.pageSize,
                  query.search,
                  orderBy,
                  filterString
                )
                  .catch(handleError) // handle network issues
                  .then(checkStatus)
                  .then(parseJSON)
                  .then((data: PaginatedResponse<StockReceipt>) => {
                    const settled = settle(
                      typeof data.count === 'number' ? data.count : null,
                      Array.isArray(data.results) ? data.results.length : 0,
                    );
                    if (!settled.apply) {
                      return;
                    }
                    hasLoaded.current = true;
                    appliedPageSize.current = settled.pageSize;
                    setErrorStatusVisible(false);
                    setEmptyDataSourceMessage(EMPTY_ROW_MSG);
                    pageData = {
                      data: data.results,
                      totalCount: settled.totalCount,
                      page: settled.pagerPage
                    };
                    setTableQuery({
                      ...tableQuery,
                      orderBy,
                      totalCount: settled.totalCount,
                      page: settled.pagerPage,
                      pageSize: settled.pageSize
                    });
                    setLoading(false);
                    resolve(pageData);
                  })
                  .catch((error: any) => {
                    const settled = settle(null, 0);
                    if (!settled.apply) {
                      return;
                    }
                    if (error) {
                      if (error.status && error.status === 500) {
                        setEmptyDataSourceMessage(ERROR_500);
                        setErrorStatusVisible(false);
                      } else if ((error.status === 403 || error.status === 401)) {
                        setEmptyDataSourceMessage(ERROR_MSG);
                        setErrorStatusVisible(true);
                      } else {
                        setEmptyDataSourceMessage(ERROR_MSG);
                        setErrorStatusVisible(false);
                      }
                    }
                    setTableQuery({
                      ...tableQuery,
                      totalCount: 0,
                      page: decision.page,
                      pageSize: decision.pageSize
                    });
                    setLoading(false);
                    resolve(pageData);
                  });
              }
            })
          }
          onRowClick={(event, rowData) => navigateToStockReceiptDetail(rowData)}

          title={
            <CustomTableTitle
              history={props.history}
              title={props.title}
              icon={SVG_ICONS.stockReceipt} />
          }
          actions={[
            {
              icon: 'refresh',
              tooltip: 'Refresh Data',
              isFreeAction: true,
              onClick: () => tableRef.current && tableRef.current.onQueryChange(),
            },
            {
              icon: 'filter_list',
              tooltip: filterVisible ? 'Hide Filters' : 'Show Filters',
              isFreeAction: true,
              iconProps: {
                color: filterVisible ? 'primary' : 'inherit',
              },
              // hidden: !isSuperAdmin(props),
              onClick: toggleFilterPanel,
            },
          ]}
        />
      </div>
    </div>
  );
}

export default StockReceiptSupplierList;
